import React from 'react';
import { teamTranslations } from '../data/teamData';
import { useLanguage } from '../context/LanguageContext';

export default function Team() {
    const { language } = useLanguage();
    const t = teamTranslations[language];

    return (
        <div className="bg-background text-on-surface font-body">
            <section className="py-24 px-8 border-t border-border">
                <div className="max-w-7xl mx-auto">
                    <h3 className="font-headline text-3xl font-extrabold text-primary mb-16 text-center uppercase tracking-tight">
                        {t.title}
                        <span className="block w-20 h-1 bg-secondary mx-auto mt-4"></span>
                    </h3>
                    <div className="grid grid-cols-3 sm:grid-cols-6 gap-4">
                        {t.members.map((member) => (
                            <div className="group" key={member.name}>
                                <div className="aspect-[3/4] bg-surface rounded-xl overflow-hidden mb-3 relative shadow-sm group-hover:shadow-lg transition-all duration-500 border border-border">
                                    <img
                                        alt={member.name}
                                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                                        src={member.image}
                                    />
                                    {/* LinkedIn button — bottom-right corner */}
                                    <a
                                        href={member.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={e => e.stopPropagation()}
                                        className="absolute bottom-2 right-2 w-7 h-7 rounded-md bg-[#0A66C2] flex items-center justify-center shadow-md"
                                        aria-label={`LinkedIn de ${member.name}`}
                                    >
                                        <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                        </svg>
                                    </a>
                                </div>
                                <h4 className="font-headline font-bold text-primary text-sm mb-0.5 leading-tight">{member.name}</h4>
                                <p className="text-[9px] font-black text-secondary uppercase tracking-[0.15em]">{member.role}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
